export const PERIOD_CALENDAR = 'period_calendar';
export const SPECIFIC_DATES_CALENDAR = 'specific_dates_calendar';
